export default __webpack_public_path__ + "c1eac04fa8340b92c506ba8d0da40c76.svg";